import {Component, inject, OnInit, signal} from '@angular/core';
import {finalize} from 'rxjs';
import {Router, RouterLink} from '@angular/router';
import {UserService} from '../../../../shared/services/user.service';
import {User} from '../../../../shared/model/user';
import {ApiResponse} from '../../../../shared/model/api-response';
import {Messages} from '../../../../shared/constants/messages';
import {ProfileFormComponent} from '../profile-form/profile-form.component';
import {AuthService} from '../../../../core/auth/auth.service';

@Component({
  selector: 'app-profile-view',
  standalone: true,
  imports: [RouterLink, ProfileFormComponent],
  templateUrl: './profile-view.component.html',
  styleUrl: './profile-view.component.css'
})
export class ProfileViewComponent implements OnInit {
  private userService: UserService = inject(UserService);
  private router: Router = inject(Router);
  protected authService: AuthService = inject(AuthService);

  protected userData = signal<User | undefined>(undefined);
  protected isLoading = signal<boolean>(false);
  protected error = signal<string | null>(null);

  ngOnInit(): void {
    this.loadUserData();
  }

  private loadUserData(): void {
    this.isLoading.set(true);
    this.userService.getMyUserData()
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: (response: ApiResponse<User>) => {
          if (response.success && response.data) {
            this.userData.set(response.data);
            this.authService.setCurrentUser(response.data);
          } else {
            this.error.set(Messages.USER_DATA_NOT_FOUND);
          }
        },
        error: () => {
          this.authService.logout();
          this.router.navigate(['/login']);
        }
      });
  }
}
